
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from "@/hooks/use-toast";

export type UploadedFiles = {
  gas: string | null;
  electricity: string | null;
  water: string | null;
};

export const useFileUpload = () => {
  const { toast } = useToast();
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFiles>({
    gas: null,
    electricity: null,
    water: null
  });

  const handleFileUpload = async (file: File, type: 'gas' | 'electricity' | 'water'): Promise<string | undefined> => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast({
          title: "Authentication required",
          description: "Please log in to upload files",
          variant: "destructive",
        });
        return;
      }
      
      const sanitizedFileName = file.name.replace(/[^\x00-\x7F]/g, '');
      const fileExt = sanitizedFileName.split('.').pop();
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      
      const filePath = `${user.id}/${type}-bill-${timestamp}.${fileExt}`;

      const { data, error: uploadError } = await supabase.storage
        .from('user_inputs_files')
        .upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (uploadError) {
        throw uploadError;
      }

      setUploadedFiles(prev => ({
        ...prev,
        [type]: data?.path || null
      }));

      return data?.path;
    } catch (error) {
      console.error('File upload error:', error);
      throw error;
    }
  };

  return {
    uploadedFiles,
    handleFileUpload
  };
};
